import { useSelector } from 'react-redux';

import { UnleashFeatureNames } from '../../modules/Unleash/featureNames';
import { getIsFeatureEnabled } from '../../selectors/features';
import {
  countryCodeIsIndonesia,
  countryCodeIsSingapore,
} from '../helpers/countryCodeHelper';
import { useGetSessionCompany } from './useGetSessionCompany';

export default function useIsLegalDocsAutoVerifyEnabled(): boolean {
  const { sessionCompany } = useGetSessionCompany();
  const isIDCompany = countryCodeIsIndonesia(sessionCompany?.CountryCode);
  const isSGCompany = countryCodeIsSingapore(sessionCompany?.CountryCode);
  const isLegalDocumentAutoVerificationEnabled = useSelector(state =>
    getIsFeatureEnabled(state, UnleashFeatureNames.empLegalDocsAutoVerify)
  );

  return (isIDCompany || isSGCompany) && isLegalDocumentAutoVerificationEnabled;
}
